import React from 'react';
import {useFormikContext} from "formik";
import {useTranslation} from "react-i18next";
import {CSSTransition} from 'react-transition-group';
import store from "@formApp/store";
import { useGoogleLogin } from '@react-oauth/google';

export default () => {
    const {t} = useTranslation();
    const {setFieldValue} = useFormikContext();
    const {loginWithWidget, formValues} = React.useContext(store);
    const {provider, data, userIsConnected} = loginWithWidget;
    const [showButton, setShowButton] = React.useState(!userIsConnected);

    React.useEffect(() => {
        window.fbAsyncInit = function() {
            FB.init({
                appId: '124855394234339', //app altervista
                xfbml: true,
                version: 'v20.0'
            });
        };
        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/it_IT/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }, []);
    const loginFB = () => {
        FB.login(res => {
            getFieldsValuesFB();
        }, {
            scope: 'public_profile,email'
        });
    };
    const getFieldsValuesFB = () => {
        FB.api('/me', {
            fields: 'first_name,last_name,email,id,picture'
        }, res => {
            const token = FB.getAccessToken();
            if (token) {
                const data = {
                    provider: 'facebook',
                    id: res.id,
                    accesToken: token,
                    first_name: res.first_name,
                    last_name: res.last_name,
                    email: res.email,
                    picture: res.picture.data.url
                };
                loginWithWidget.setData(data);
                loginWithWidget.setConnection(true);
                fillForm(data);
            }
        });
    };
    const fillForm = (data) => {
        if (data.error) return;
        formValues.setValue('Nome', data.first_name);
        setFieldValue('Nome', data.first_name);
        formValues.setValue('Cognome', data.last_name);
        setFieldValue('Cognome', data.last_name);
        if (data.email) {
            formValues.setValue('Email', data.email);
            setFieldValue('Email', data.email);
            formValues.setValue('mailConfirm', data.email);
            setFieldValue('mailConfirm', data.email);
        }
        if (data.provider == 'google') {
            formValues.setValue('googleid', data.id);
            setFieldValue('googleid', data.id);
            formValues.setValue('googletokenid', data.accesToken);
            setFieldValue('googletokenid', data.accesToken);
        } else {
            formValues.setValue('FacebookId', data.id);
            setFieldValue('FacebookId', data.id);
            formValues.setValue('FacebookAT', data.accesToken);
            setFieldValue('FacebookAT', data.accesToken);
        }
    };
    const fbConnect = () => {
        FB.getLoginStatus(response => {
            if (response.status === 'connected') {
                getFieldsValuesFB();
            } else {
                loginFB();
            }
        });
    };
    const googleLoginSuccess = ({ code }) => {
        const formEncoded = new URLSearchParams();
        formEncoded.append('code', code);
        fetch('https://aa.altervista.org/google-connect.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formEncoded
        }).then((res) => res.json()).then(
            (res) => {
                if (res.id_token && res.valid) {
                    const data = {
                        provider: 'google',
                        id: res.id_token_decoded.sub,
                        accesToken: res.id_token,
                        first_name: res.id_token_decoded.given_name,
                        last_name: res.id_token_decoded.family_name,
                        email: res.id_token_decoded.email,
                        picture: res.id_token_decoded.picture
                    };
                    loginWithWidget.setData(data);
                    loginWithWidget.setConnection(true);
                    fillForm(data);
                }
            }
        );
    };
    const googleLoginFailure = (response) => {
        console.log(response);
    };
    const loginGoogle = useGoogleLogin({
        onSuccess: googleLoginSuccess,
        onError: googleLoginFailure,
        flow: 'auth-code',
        scope: 'email profile openid'
    });
    const triggerEdit = (e) => {
        e.preventDefault();
        loginWithWidget.setConnection(false);
        formValues.setValue('googleid', '');
        setFieldValue('googleid', '');
        formValues.setValue('googletokenid', '');
        setFieldValue('googletokenid', '');
        formValues.setValue('FacebookId', '');
        setFieldValue('FacebookId', '');
        formValues.setValue('FacebookAT', '');
        setFieldValue('FacebookAT', '');
    };

    return (
        <div className="loginWithWidget">
            <CSSTransition
                in={userIsConnected}
                timeout={300}
                classNames="loginWith"
                unmountOnExit
                onEnter={() => setShowButton(false)}
                onExited={() => setShowButton(true)}
            >
                <div className="loginWithConn">
                    <div className="loginWithPicture">
                        <img src={data && data.picture}/>
                    </div>
                    <div className="loginWithWelcome">
                        {t('Ciao')} <span className="loginWithName">{data && data.first_name}</span>,<br/>
                        <span>{data && data.provider == 'facebook' ? t('Continua la registrazione con il tuo profilo di Facebook') : t('Continua la registrazione con il tuo account Google')} </span>
                        <span className='editloginWithInfo'><em>{t('oppure')} </em><a href="" onClick={triggerEdit}>{t('Modifica')}</a></span>
                    </div>
                </div>
            </CSSTransition>
            { showButton &&
            <>
                <span>{t('oppure accedi con')} </span>
                <button type='button' className='btn-social-login btn-fb-connect' onClick={fbConnect}><span className="facebook-icon"></span>Facebook</button>

                <button type='button' className='btn-social-login btn-google-login' onClick={loginGoogle}><span className="google-icon"></span>Google</button>
            </>
            }
        </div>
    )
}
